/**
 * Balance threshold (in dollars) at or below which the UI surfaces the
 * "low balance" interaction card. Sized so users see the warning early
 * enough to top up before a long orchestration runs out mid-stream.
 */
export const LOW_BALANCE_THRESHOLD_DOLLARS = 0.2

/**
 * Plan name (lowercased) that identifies the free tier. Used to decide
 * whether to surface the upgrade card vs. the top-up card.
 */
export const FREE_PLAN_NAME = 'free'
